module.exports = __webpack_public_path__ + "static/media/icon-heart-white.1dd9a326.svg";